import { useSyncExternalStore } from "react";
import { authTokenManager } from "./authTokenManager";
export function useL500Token() {
    return useSyncExternalStore(listener => authTokenManager.subscribe(listener), () => authTokenManager.getToken(), () => null);
}
//# sourceMappingURL=useL500Token.js.map